<template>
  <div class="relative flex flex-col items-center">
    <textarea
      :class="[
        'w-full resize-none border-none bg-background text-center text-sm text-background-fg/87 outline-none placeholder:text-transparent focus:border-none focus:shadow-none focus:ring-0',
        $style.noteInputeTextArea,
      ]"
      placeholder="I'm invisible"
      maxlength="64"
      :value="modelValue"
      enterKeyHint="done"
      @input="handleInput"
      @keydown.enter="handleEnter"
    />
    <div
      :class="[
        'pointer-events-none invisible absolute top-0 flex items-center space-x-1 text-sm text-background-fg/60',
        $style.noteInputPlaceholder,
      ]"
    >
      <span>Add Note</span>
      <IconPencil class="py-px text-background-fg/50" />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ modelValue: string }>()

const emit = defineEmits(["update:modelValue"])

const handleInput = (event: Event) => {
  emit(
    "update:modelValue",
    (event.target as HTMLInputElement).value
  )
}

const handleEnter = (event: Event) =>
  (event?.target as HTMLInputElement)?.blur()
</script>

<style module lang="scss">
.noteInputeTextArea:placeholder-shown {
  & + .noteInputPlaceholder {
    visibility: visible;
  }

  &:focus + .noteInputPlaceholder {
    visibility: hidden;
  }
}
</style>
